import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { WhitelabelOrganizationShow } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getWhitelableOrganization(axios: AxiosInstance, id: number): Promise<WhitelabelOrganizationShow> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/whitelabel-organizations/${id}`);
  return data;
}

export default function useWhitelableOrganizationQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getWhitelableOrganization(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number) {
  return ['Whitelable Organization', id] as const satisfies QueryKey;
}

useWhitelableOrganizationQuery.getKey = getKey;
